import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  closeDrawerButtonAriaLabel: {
    defaultMessage: 'Close Import Drawer',
    description: 'Label for button that closes import drawer',
    id: '+WZKP4',
  },
});
